import API from '../Services/API';
import Model from './Model';

const useJournal = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'journal',
        stateKey: ['notifications', 'journal'],
        fetchData: async () => API.get('/notifications'),
        registerAdditionalMethods: (opts) => {
            return {
                updateNotificationPreferences: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/notifications/preferences', data),
                        'Notification preferences updated',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading notifications.',
    })
}

const useJournalCounts = () => {
    return Model({
        alwaysRefresh: true,
        returnDataKey: 'counts',
        stateKey: ['notifications', 'journalCounts'],
        fetchData: () => API.get(`/notifications/activeCounts`),
    })
}


export {
    useJournal,
    useJournalCounts,
}
